import React from 'react';
import styles from './footer.module.css';

class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      year: '- 2019'
    }
  }
  componentDidMount() {
    let year = new Date().getFullYear();
    this.setState({
      year: '- ' + year
    })
  }
  render () {
    return(
      <footer className={styles.footer}>
        {
          this.props.type === 'pubinner'?
            <div className="inner inner_small">© 2000 {this.state.year}</div>
            :
            <div className="inner">© 2000 {this.state.year}</div>
        }
      </footer>
    )
  }
}

export default Footer;